import { useTranslation } from "react-i18next";

export const EmptyList = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.courseLayout.general',
    });
    
    return (
        <h2 className="text-2xl text-center font-bold my-10">{t('emptyList')}</h2>
    );
};
